import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'onefaceui-react-components';
import { getResourceTo } from 'react/utils/utils';
import { StopStatus } from './styles';

import CompletedStop from 'static/images/completed-stop.svg';
import RedeliveryStop from 'static/images/redelivery-stop.svg';
import UndeliverableStop from 'static/images/undeliverable-stop.svg';
import CanceledStop from 'static/images/canceled-stop.svg';
import PendingStop from 'static/images/pending-stop.svg';
import PartiallyCompletedStop from 'static/images/partially-completed-stop.svg';
import InProgressStop from 'static/images/progress-stop.svg';

const stopStatusIcons = {
  PENDING: PendingStop,
  DELIVERED: CompletedStop,
  REDELIVERED: RedeliveryStop,
  UNDELIVERED: UndeliverableStop,
  CANCELED: CanceledStop,
  IN_PROGRESS: InProgressStop,
  PARTIALLY_DELIVERED: PartiallyCompletedStop
};

const stopStatusDescriptions = {
  PENDING: 'Greenmile.Stop.IconDescription.pending',
  DELIVERED: 'Greenmile.Stop.IconDescription.completed',
  REDELIVERED: 'Greenmile.Stop.IconDescription.redelivery',
  UNDELIVERED: 'Greenmile.Stop.IconDescription.undeliverable',
  CANCELED: 'Greenmile.Stop.IconDescription.cancel',
  IN_PROGRESS: 'Greenmile.Stop.IconDescription.inProgress',
  PARTIALLY_DELIVERED: 'Greenmile.Stop.IconDescription.partiallyDelivered'
};

/**
 * Component to display stop status information
 * Single responsibility: Render the stop status with icon and text
 */
const StopStatusDisplay = ({ stopStatus, stopDetail }) => {
  return (
    <Flex className="stop-status" alignItems="center" gap={4}>
      <StopStatus className={stopStatus} gap={6} alignItems="center">
        <Flex
          justifyContent="center"
          alignItems="center"
          className="status-icon"
        >
          <img
            src={stopStatusIcons[stopStatus]}
            alt={getResourceTo(stopStatusDescriptions[stopStatus])}
          />
        </Flex>
        <Flex>
          {stopDetail?.actualSequenceNum && (
            <Text size="xs" type="light" weight="bold">
              {stopDetail.actualSequenceNum}/
            </Text>
          )}
          <Text size="xs" type="light">
            {stopDetail?.plannedSequenceNum}
          </Text>
        </Flex>
      </StopStatus>
      <Text size="xs">
        {getResourceTo(stopStatusDescriptions[stopStatus])}
      </Text>
    </Flex>
  );
};

StopStatusDisplay.propTypes = {
  stopStatus: PropTypes.string.isRequired,
  stopDetail: PropTypes.shape({
    actualSequenceNum: PropTypes.oneOfType([
      PropTypes.string, 
      PropTypes.number
    ]),
    plannedSequenceNum: PropTypes.oneOfType([
      PropTypes.string, 
      PropTypes.number
    ])
  })
};

StopStatusDisplay.defaultProps = {
  stopDetail: {}
};

export default StopStatusDisplay;
